import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Col, DatePicker, Modal, Row, Select, Space } from "antd"
import { DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

interface formRow {
    service_type_id: undefined | string,
    reserve_date: undefined | string,
}

interface Prop {
    storeID?: string
    onFinish?: () => void
}

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 客人姓名
    check_in_phone: string // 手机号码
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期（预计入住时间）
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住时间
    check_out_time_init: string // 预计出所时间
    check_out_time_finally: string // 实际出所时间
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    deal_item_name: string // 签单套餐名称
    check_in_total_days: number // 入住总天数，整数类型
    check_in_already_days: number // 已入住天数，整数类型
    check_in_left_days: number // 剩余天数，整数类型
    item_days: number // 套餐入住天数，整数类型
    gift_days: number // 赠送天数，整数类型
    deal_records_remark: string // 签单备注
    store_id: string // 签单门店id
    deal_prov_pic_list: string // 合同凭证图片
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [clientData, setClientData] = useState<Client>()
    const [babys, setBabys] = useState<any[]>([])
    const [babyID, setBabyID] = useState<string>()

    let formRow: formRow = {
        service_type_id: undefined,
        reserve_date: undefined,
    }

    const [formData, setFormData] = useState<formRow[]>([{
        service_type_id: undefined,
        reserve_date: undefined,
    }])

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/baby_list', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setBabys(res)
        })

        baseAxiosNoInfo('/keeper/check_in/detail/base_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            if (res) {
                setClientData(res)
            }
        })
    }

    const addMoreRow = () => {
        setFormData([...formData, formRow])
    }

    const deleteRow = (index: number) => {
        if (formData.length > 1) {
            let reciveD = _.cloneDeep(formData)
            reciveD.splice(index, 1)

            setFormData(reciveD)
        }
    }

    const handleChange = (index: number, attr: string, value: any) => {
        let reciveD: any = _.cloneDeep(formData)
        reciveD[index][attr] = value

        setFormData(reciveD)
    }

    useEffect(() => {
        getClientInfo()
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/reserve_baby_service', {
            check_in_id: param.id,
            baby_id: babyID,
            reserve_list: formData

        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                prop.onFinish && prop.onFinish()
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 预约宝宝服务 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>预约宝宝服务</Button>

        <Modal title="预约宝宝服务" width={500} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Row style={{ marginBottom: 20 }}>
                <Col span={12}>
                    <div>
                        <Space wrap>
                            <p>客人姓名：</p>
                            <p>{clientData?.check_in_user_name}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p>手机号码：</p>
                            <p>{clientData?.check_in_phone}</p>
                        </Space>
                    </div>
                </Col>
            </Row>

            <Select style={{ marginBottom: 20, width: 150 }} placeholder="选择服务的宝宝" value={babyID} onChange={(e: any) => {
                setBabyID(e)
            }}>
                {babys.map(el => <Option value={el.id}>{el.nick_name}</Option>)}
            </Select>

            {formData.map((el, index: number) => <Row gutter={8} style={{ marginBottom: 8, userSelect: 'none' }}>
                <Col span={10}>
                    <Select placeholder="服务类型" value={el.service_type_id} style={{ width: '100%' }} onChange={(v: string) => {
                        handleChange(index, 'service_type_id', v)
                    }}>
                        <Option value={1} key={1}>满月派对</Option>
                    </Select>
                </Col>

                <Col span={7}>
                    <DatePicker onChange={(v: any) => {
                        handleChange(index, 'reserve_date', v.format('YYYY-MM-DD'))
                    }} />
                </Col>

                <Col span={7} style={{ paddingTop: 4 }}>
                    <DeleteOutlined onClick={() => {
                        deleteRow(index)
                    }} style={{ cursor: 'pointer' }} />
                </Col>
            </Row>)}

            <Button onClick={addMoreRow} style={{ marginTop: 16 }} size="small" type="primary">添加服务</Button>
        </Modal>
    </Fragment>
}